import { css } from '@emotion/css'
import { borderRadius } from '../../styles'
import { getSkeletonColors } from '../../themes'

const styles = {
  button: css({
    border: 'none',
    outline: 'none',
    borderRadius: borderRadius.default,
    padding: 0,
    display: 'inline-block',
  }),
}

export default styles

export const buttonTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })

export const buttonSize = size => {
  switch (size) {
    case 'small':
      return css({
        height: 30,
        minWidth: 90,
      })

    case 'medium':
      return css({
        height: 40,
        minWidth: 120,
      })

    default:
      return css({
        height: 35,
        minWidth: 100,
      })
  }
}
